import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 20 20"
    enableBackground="new 0 0 20 20"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        '.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#Rectangle_00000116954311193360918230000009241673633985993371_)}'
      }
    </style>
    <g id="Icon-Architecture_x2F_64_x2F_Arch_x5F_Amazon-GuardDuty_x5F_64">
      <g id="Icon-Architecture-BG_x2F_64_x2F_Security-Identity-Compliance">
        <linearGradient
          id="Rectangle_00000068660429026886015100000016612859638333478061_"
          gradientUnits="userSpaceOnUse"
          x1={-670.513}
          y1={352.55}
          x2={-670.263}
          y2={352.8}
          gradientTransform="matrix(80 0 0 -80 53641 28224)"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#bd0816',
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: '#ff5252',
            }}
          />
        </linearGradient>
        <path
          id="Rectangle"
          style={{
            fillRule: 'evenodd',
            clipRule: 'evenodd',
            fill: 'url(#Rectangle_00000068660429026886015100000016612859638333478061_)',
          }}
          d="M0 0h20v20H0z"
        />
      </g>
      <path
        id="Amazon-GuardDuty_Icon_64_Squid"
        d="M11.75 10.704c-.005.453-.135 1.875-1.5 2.03V7.26l1.5.64v2.805zm-3.5-.013V7.898l1.5-.639v5.475c-1.366-.156-1.495-1.588-1.5-2.043zm1.652-4.04-2 .852a.25.25 0 0 0-.152.23v2.961c.013 1.18.61 2.556 2.25 2.556 1.639 0 2.236-1.369 2.25-2.543V7.733c0-.1-.06-.191-.152-.23l-2-.852a.252.252 0 0 0-.196 0zm2.848 4.055c0 .124-.04 3.044-2.75 3.044s-2.75-2.929-2.75-3.053v-3.46L10 6.066l2.75 1.171v3.47zm.348-3.864-3-1.278a.249.249 0 0 0-.196 0l-3 1.278a.25.25 0 0 0-.152.23v3.625c0 .035.037 3.553 3.25 3.553s3.25-3.508 3.25-3.543V7.072c0-.1-.06-.19-.152-.23zm3.402 4.235-.856-.05a.256.256 0 0 0-.258.196 5.474 5.474 0 0 1-.713 1.722.25.25 0 0 0 .045.32l.64.57-1.523 1.523-.57-.638a.25.25 0 0 0-.32-.044c-.53.335-1.11.575-1.723.714a.25.25 0 0 0-.194.258l.049.852H8.923l.049-.853a.25.25 0 0 0-.195-.258 5.483 5.483 0 0 1-1.722-.715.25.25 0 0 0-.32.045l-.57.639-1.523-1.523.639-.57a.25.25 0 0 0 .045-.32 5.473 5.473 0 0 1-.713-1.722.253.253 0 0 0-.258-.195l-.855.049V8.923l.857.049a.258.258 0 0 0 .258-.194c.138-.61.379-1.189.714-1.72a.25.25 0 0 0-.045-.32l-.642-.573 1.523-1.523.572.642a.25.25 0 0 0 .32.045 5.48 5.48 0 0 1 1.72-.712.25.25 0 0 0 .195-.258L8.923 3.5h2.154l-.049.86a.25.25 0 0 0 .195.257c.61.139 1.188.378 1.718.713a.25.25 0 0 0 .32-.045l.574-.643 1.523 1.523-.641.572a.25.25 0 0 0-.045.32c.335.53.575 1.11.713 1.72.027.12.145.199.258.195l.857-.049v2.154zm.422-2.6a.251.251 0 0 0-.186-.068l-.913.052a5.972 5.972 0 0 0-.618-1.49l.683-.609a.25.25 0 0 0 .01-.363L14.002 4.1a.25.25 0 0 0-.363.01l-.612.686a5.974 5.974 0 0 0-1.487-.617l.052-.916a.25.25 0 0 0-.25-.264H8.66a.25.25 0 0 0-.25.264l.052.915a5.983 5.983 0 0 0-1.489.616l-.61-.683a.25.25 0 0 0-.363-.01L4.102 5.998a.25.25 0 0 0 .01.363l.684.61a5.97 5.97 0 0 0-.618 1.489l-.914-.052a.25.25 0 0 0-.264.25v2.682a.25.25 0 0 0 .264.25l.911-.052c.138.524.345 1.024.618 1.492l-.681.607a.25.25 0 0 0-.01.363L5.998 15.9a.25.25 0 0 0 .363-.01l.607-.682c.469.274.97.481 1.492.62l-.052.909a.25.25 0 0 0 .25.264h2.682a.25.25 0 0 0 .25-.264l-.052-.91a5.97 5.97 0 0 0 1.492-.618l.607.68a.249.249 0 0 0 .363.01l1.897-1.897a.25.25 0 0 0-.01-.363l-.682-.608c.273-.468.48-.968.618-1.491l.912.052a.249.249 0 0 0 .264-.25V8.658a.25.25 0 0 0-.078-.181z"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          fill: '#fff',
        }}
      />
    </g>
  </svg>
);

export default SvgComponent;
